module.exports = __webpack_public_path__ + "img/verifikasi-web-icon-2.d9b8f250.svg";